// CheckVersion.js
var CheckVersion = pc.createScript('checkVersion');

CheckVersion.attributes.add('versionNo', {type: 'string'});
CheckVersion.attributes.add('versionLabel',{type: 'entity'});

var gameVersion = "";

CheckVersion.prototype.initialize = function() {
    
    console.log("Version: " + this.versionNo);
    //this.versionLabel.element.text = this.versionNo;
    gameVersion = this.versionNo;
};



